// PWA service-worker registration with update + offline-ready signaling.
// Dispatches CustomEvents that UI components (e.g. a toast) can listen to:
//   'teddo:pwa-update-available' — detail.updateSW() applies the update
//   'teddo:pwa-offline-ready'    — app is cached and ready to work offline
import { registerSW } from 'virtual:pwa-register'

export function initPwa() {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  const updateSW = registerSW({
    onNeedRefresh() {
      window.dispatchEvent(
        new CustomEvent('teddo:pwa-update-available', {
          detail: { updateSW: () => updateSW(true) },
        })
      )
    },
    onOfflineReady() {
      window.dispatchEvent(new CustomEvent('teddo:pwa-offline-ready'))
    },
    onRegisterError(err) {
      console.warn('[Teddo PWA] service worker registration failed:', err)
    },
  })
}
